import Vue from 'vue'
import store from './../store'
import routes from './routes'
import Router from 'vue-router'
import roleAcces from './middleware/roleAcces'
import isAuthorized from './middleware/isAuthorized'
import checkDevice from './middleware/checkDevice'
import catchScanExit from './middleware/catchScanExit'

//import middleware
Vue.use(Router)


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})

router.beforeEach((to, from, next) => {
  if(to.name == 'callback') { // check if "to"-route is "callback" and allow access
    next();
  } else if (router.app.$auth.checkAuthentication()) { // if authenticated allow access else open login page
    next();
  } else { // Show not logged in page
    next('/login');
  }
})


// isAuthorized(router)
// roleAcces(router)
checkDevice(router);
catchScanExit(router);
export default router
